import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProviders } from './app/providers';
import { App } from './app/App';
import 'katex/dist/katex.min.css';
import './index.css';

// Auto-recover from dynamic module import failures after deployments (capped at 1 reload attempt)
window.addEventListener('vite:preloadError', (event) => {
  const reloadKey = `preload_reload_${window.location.pathname}`;
  const reloadAttempts = parseInt(sessionStorage.getItem(reloadKey) || '0', 10);
  if (reloadAttempts < 1) {
    sessionStorage.setItem(reloadKey, String(reloadAttempts + 1));
    console.warn('Vite preload error detected, reloading page for latest assets...', event);
    window.location.reload();
  } else {
    console.warn('Vite preload error persisted, suppressing reload loop.');
  }
});

window.addEventListener('error', (event) => {
  const msg = (event.message || '') + (event.error?.message || '');
  if (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Expected a JavaScript-or-Wasm module script') ||
    msg.includes('Importing a module script failed')
  ) {
    const reloadKey = `chunk_reload_${window.location.pathname}`;
    const reloadAttempts = parseInt(sessionStorage.getItem(reloadKey) || '0', 10);
    if (reloadAttempts < 1) {
      sessionStorage.setItem(reloadKey, String(reloadAttempts + 1));
      console.warn('Dynamic chunk import failed after code update. Refreshing page...', event);
      window.location.reload();
    } else {
      console.warn('Dynamic chunk import error persisted, suppressing reload loop.');
    }
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);
